import logo from './elite_logo_white.png';
import logoLogin from './elite_logo_black.png';

export const settings = {
    "title": "Elito To Be",
    "apiUrl": "https://elitetobe.yec-playground.it/api",
    "ckdPath": "https://elitetobe.yec-playground.it/",
    "googleMapKey": "AIzaSyAlJm8u1CoH2YUYFJW8_evAji5Nso7JRRw",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "manufacturing_process_model": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_stocks": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_transport_document": {
            "limit": 5,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_open_customer_rows": {
            "limit": 500,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_open_customer_rows_with_order_available": {
            "limit": 1000,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_close_customer_rows": {
            "limit": 100,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "item_model_suppliers": {
            "limit": 50,
            "sortingField": 'active',
            "sortingOrder": 'desc'
        },
        "customer_invoices": {
            "limit": 50,
            "sortingField": 'internalCode',
            "sortingOrder": 'desc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "logoLogin": logoLogin,
    "modalDefaultSize": {
        crop: 'xl',
        delete: 'xl',
        details: 'xl',
        entityCompiler: 'xl',
        entityConfig: 'xl',
        entityExport: 'xl',
        entityImport: 'xl',
        entityViewer: 'xl',
        list: 'xl',
        picker: 'xl',
        viewFile: 'xl'
    },
    "modalFullscreen": {
        list: true,
        listPicker: true,
        picker: true
    },
    "usingCache": false,
    "fatturazione": false
}